import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { getVariationTitle } from '@telialt/core-eshop/src/product/ProductVariationBadges/getVariationTitle';
import { BadgeBlockTitleProps } from '@telialt/core-eshop/src/product/ProductVariationBadges/model';

import { OutOfStockLabel, VariantLabel } from './VariantSelector.styles';

export const RetailsVariantBadgeBlockTitle: FC<BadgeBlockTitleProps> = ({ variation }) => {
    const { t } = useTranslations();

    const title = getVariationTitle(variation, t);
    const showOutOfStockLabel = variation?.isOutOfStock;

    if (!title) {
        return null;
    }

    return (
        <VariantLabel tag="h2" variant="title-100">
            {title}
            {showOutOfStockLabel && (
                <OutOfStockLabel aria-label={t['eshop.product_page.stock_status.out_of_stock']}>
                    {t['eshop.product_page.stock_status.out_of_stock']}
                </OutOfStockLabel>
            )}
        </VariantLabel>
    );
};
